module.exports = __webpack_public_path__ + "static/media/background.f5536d68.png";